import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

export default function ErrorPage() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location]);
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "2rem",
      }}
    >
      <img
        style={{ width: "280px" }}
        src={require("../assets/vector/404.svg").default}
        alt=""
      />
      <Link to="/">
        <button className="bt ripple mt2">Return</button>
      </Link>
    </div>
  );
}
